export const state = {
  ids: [],
  bounds: null,
  autoZoom: false,
  enabled: true,
  isLoaded: false,
  token: '',
}

export const getters = {
  ids: (state) => state.ids,
  bounds: (state) => state.bounds,
  autoZoom: (state) => state.autoZoom,
  enabled: (state) => state.enabled,
  isLoaded: (state) => state.isLoaded,
  token: (state) => state.token,
}

export const mutations = {
  SET_IDS(state, payload) {
    const incoming = Array.isArray(payload) ? payload : [payload]
    const unique = new Set([...(state.ids || []), ...incoming.filter((v) => v != null)])
    state.ids = Array.from(unique)
  },
  SET_BOUNDS(state, payload) {
    state.bounds = payload
  },
  SET_AUTO_ZOOM(state, payload) {
    state.autoZoom = !!payload
  },
  SET_ENABLED(state, payload) {
    state.enabled = !!payload
  },
  SET_IS_LOADED(state, payload) {
    state.isLoaded = !!payload
  },
  SET_TOKEN(state, payload) {
    state.token = payload || ''
  },
  TOGGLE_ENABLED(state, value) {
    state.enabled = value !== undefined ? !!value : !state.enabled
  },
}

export const actions = {
  setOrthophotos({ commit }, payload) {
    const ids = (payload?.ids || []).filter((v) => v != null)
    commit('SET_IDS', ids)
    if (payload?.bounds) {
      commit('SET_BOUNDS', payload.bounds)
    }
    if (payload?.autoZoom !== undefined) {
      commit('SET_AUTO_ZOOM', payload.autoZoom)
    }
    if (payload?.isLoaded !== undefined) {
      commit('SET_IS_LOADED', payload.isLoaded)
    }
    if (payload?.token !== undefined) {
      commit('SET_TOKEN', payload.token)
    }
  },
  toggleEnabled({ commit }, value) {
    commit('TOGGLE_ENABLED', value)
  },
}

